import { all, fork } from 'redux-saga/effects'
import {
  signInWithDetails,
  signOutUser,
  getCurrentUser,
} from './Auth'

export default function* root() {
  yield all([
    fork(signInWithDetails),
    fork(signOutUser),
    fork(getCurrentUser),
  ])
}
